"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XYPositionSchema = void 0;
const zod_1 = require("zod");
exports.XYPositionSchema = zod_1.z.tuple([zod_1.z.number(), zod_1.z.number()]);
//# sourceMappingURL=XYPosition.js.map